export default {
  // Settings
  "settings": "Configuración",
  "profile": "Perfil",
  "security": "Seguridad",
  "theme": "Tema",
  "feedback": "Comentarios",
  "data": "Datos",
  "appearance_settings": "Configuración de Apariencia",
  "select_theme": "Selecciona tu tema preferido",
  "light": "Claro",
  "dark": "Oscuro",
  "system": "Sistema",
  "language_changed": "Idioma cambiado a",
  "failed_update_language": "Error al actualizar el idioma",
  "profile_settings": "Configuración de perfil",
  "username_cannot_change": "No puedes cambiar tu nombre de usuario durante",
  "more_days": "días más",
  "email_cannot_change": "El correo electrónico no se puede cambiar",
  "profile_links": "Enlaces de perfil",
  "link_one": "Enlace 1",
  "link_two": "Enlace 2",
  "password_change": "Cambiar contraseña",
  "current_password": "Contraseña actual",
  "new_password": "Nueva contraseña",
  "confirm_password": "Confirmar contraseña",
  "update_password": "Actualizar contraseña",
  "password_must_be": "La contraseña debe tener entre 8 y 25 caracteres",
  "security_questions": "Preguntas de seguridad",
  "security_question": "Pregunta de seguridad",
  "update_security_questions": "Actualizar preguntas de seguridad",
  "setup_security_questions": "Configurar preguntas de seguridad",
  "select_question": "Seleccionar pregunta",
  "your_answer": "Tu respuesta",
  "enter_your_answer": "Ingresa tu respuesta",
  "submit_feedback": "Enviar comentarios",
  "feedback_type": "Tipo de comentario",
  "general_feedback": "Comentarios generales",
  "bug_report": "Reporte de error",
  "feature_request": "Solicitud de función",
  "airport_request": "Solicitud de nuevo aeropuerto",
  "airport_iata": "Código IATA del aeropuerto",
  "airport_name": "Nombre del aeropuerto",
  "airport_location": "Ubicación del aeropuerto",
  "your_feedback": "Tu comentario",
  "data_management": "Gestión de datos",
  "delete_all_films": "Eliminar todas las películas",
  "delete_films_warning": "Esto eliminará permanentemente todas las películas de tu inventario. Esta acción no se puede deshacer.",
  "delete_all_reviews": "Eliminar todas las reseñas",
  "delete_reviews_warning": "Esto eliminará permanentemente todas tus reseñas. Esta acción no se puede deshacer.",
  "delete_account": "Eliminar cuenta",
  "delete_account_warning": "Advertencia: Esta acción no se puede deshacer. Esto eliminará permanentemente tu cuenta y todos tus datos de nuestros servidores.",
  "account_deleted_success": "Tu cuenta ha sido eliminada exitosamente",
  "account_deletion_failed": "Error al eliminar la cuenta",
  "reviews_deleted_success": "Todas tus reseñas han sido eliminadas exitosamente",
  "reviews_deletion_failed": "Error al eliminar las reseñas",
  "films_deleted_success": "Todas tus películas han sido eliminadas exitosamente",
  "films_deletion_failed": "Error al eliminar las películas",
  "confirm_delete_films": "¿Estás seguro de que deseas eliminar todas tus películas? Esta acción no se puede deshacer.",
  "confirm_delete_reviews": "¿Estás seguro de que deseas eliminar todas tus reseñas? Esta acción no se puede deshacer.",
  "confirm_delete_account": "¿Estás seguro de que deseas eliminar tu cuenta? Esta acción no se puede deshacer.",
  "create_username": "Crear nombre de usuario",
  "username_required_description": "Por favor crea un nombre de usuario para tu cuenta. Los nombres de usuario deben ser únicos y pueden contener letras, números y guiones bajos.",
  "username": "Nombre de usuario",
  "username_placeholder": "Ingresa un nombre de usuario",
  "username_requirements": "El nombre de usuario debe tener entre 4 y 25 caracteres y solo puede contener letras, números y guiones bajos.",
  "save_username": "Guardar nombre de usuario",
  "username_taken": "Este nombre de usuario ya está en uso",
  "username_set_success": "Nombre de usuario establecido con éxito",
  "username_set_error": "Error al establecer el nombre de usuario"
};
